const _temp0 = require("./PlayerShip/PlayerShip.entity.js");


const _temp1 = require("./common/Radar.entity.js");

const _temp2 = require("./common/Weapons.entity.js");

const _temp3 = require("./common/powerups/Powerups.entity.js");



const _temp4 = require("./intro/IntroShip.entity.js");


const _temp5 = require("./scenery/Sun.entity.js");


const _temp6 = require("./enemies/BattleShip/BattleShip.entity.js");


const _temp7 = require("./enemies/BulletCannon/BulletCannon.entity.js");


const _temp8 = require("./enemies/BulletDrone/BulletDrone.entity.js");


const _temp9 = require("./enemies/Drone/Drone.entity.js");


const _temp10 = require("./enemies/DroneShip/DroneShip.entity.js");


const _temp11 = require("./enemies/Helicopter/Helicopter.entity.js");


const _temp12 = require("./enemies/LargeDrone/LargeDrone.entity.js");


const _temp13 = require("./enemies/LaserCannon/LaserCannon.entity.js");


const _temp14 = require("./enemies/Mine/Mine.entity.js");


const _temp15 = require("./enemies/MineCannon/MineCannon.entity.js");



const _temp16 = require("./sinterklaas/Bird/Bird.entity.js");


const _temp17 = require("./sinterklaas/Fish/Fish.entity.js");


const _temp18 = require("./sinterklaas/House/House.entity.js");


const _temp19 = require("./sinterklaas/Jinte/Jinte.entity.js");


const _temp20 = require("./sinterklaas/Seagull/Seagull.entity.js");



module.exports = {
  "PlayerShip":   {
    "PlayerShip":     {
      "js": _temp0
    }
  },
  "common":   {
    "Radar":     {
      "js": _temp1
    },
    "Weapons":     {
      "js": _temp2
    },
    "powerups":     {
      "Powerups":       {
        "js": _temp3
      }
    }
  },
  "intro":   {
    "IntroShip":     {
      "js": _temp4
    }
  },
  "scenery":   {
    "Sun":     {
      "js": _temp5
    }
  },
  "enemies":   {
    "BattleShip":     {
      "BattleShip":       {
        "js": _temp6
      }
    },
    "BulletCannon":     {
      "BulletCannon":       {
        "js": _temp7
      }
    },
    "BulletDrone":     {
      "BulletDrone":       {
        "js": _temp8
      }
    },
    "Drone":     {
      "Drone":       {
        "js": _temp9
      }
    },
    "DroneShip":     {
      "DroneShip":       {
        "js": _temp10
      }
    },
    "Helicopter":     {
      "Helicopter":       {
        "js": _temp11
      }
    },
    "LargeDrone":     {
      "LargeDrone":       {
        "js": _temp12
      }
    },
    "LaserCannon":     {
      "LaserCannon":       {
        "js": _temp13
      }
    },
    "Mine":     {
      "Mine":       {
        "js": _temp14
      }
    },
    "MineCannon":     {
      "MineCannon":       {
        "js": _temp15
      }
    }
  },
  "sinterklaas":   {
    "Bird":     {
      "Bird":       {
        "js": _temp16
      }
    },
    "Fish":     {
      "Fish":       {
        "js": _temp17
      }
    },
    "House":     {
      "House":       {
        "js": _temp18
      }
    },
    "Jinte":     {
      "Jinte":       {
        "js": _temp19
      }
    },
    "Seagull":     {
      "Seagull":       {
        "js": _temp20
      }
    }
  }
}